import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { EmpdProvider } from './Context'
import axios from './axiosConfig'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react'
import MsalInstance from './Components/Msal/Msal';
import AuthCallback from "./Components/AuthCallback";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const init = async () => {
    const result = await axios.get('/empd/microsoft_ad/clientid')
    const msalInstance = MsalInstance({ clientId: result.data.clientId })
    await msalInstance.initialize()
    root.render(
		<MsalProvider instance={msalInstance}>
			<EmpdProvider>
        		<App />
        	</EmpdProvider>
		</MsalProvider>
    );
}

init()


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
